document.addEventListener("DOMContentLoaded", function () {
  const allowedDomains = ["@sierratextiles.com", "@card-software.com"];
  const restrictedUrls = ["/support", "/hub", "/merch"];
  const email = window.CustomerEmail?.toLowerCase();
  console.log(email)
  const sierraElements = document.querySelectorAll('[data-sierra-only="true"]');

  console.log("Found elements requiring Sierra access:", sierraElements.length);
  console.log(email)
  const isAllowed = email ? allowedDomains.some((domain) => email.endsWith(domain)) : false;

    if (!isAllowed) {
    // Hide restricted menu links
    const currentPath = window.location.pathname.replace(/\/+$/, ""); // remove trailing slashes
    console.log(currentPath)
    restrictedUrls.forEach((path) => {
      const cleanPath = path.replace(/\/+$/, ""); // remove trailing slash from rule
      if (currentPath === cleanPath) {
        window.location.href = "/";
      }
    });

    // // Optional: Redirect user if they somehow land on a restricted page
    if (restrictedUrls.includes(window.location.pathname)) {
      window.location.href = "/";
    }
  }

  sierraElements.forEach((element) => {
    if (!email) {
      console.log("No email – hiding element");
      element.style.display = "none";
      return;
    }
 
    console.log("Is allowed:", isAllowed);

    if (!isAllowed) {
      console.log("Hiding element due to domain restriction");
      element.style.display = "none";
    }
  });


});